import * as React from 'react'
import { BREAKPOINT_DESKTOP } from 'static/constants'
import styled from 'styled-components'

interface IProps {
  childrenWithProps: React.ReactElement<any, string | React.JSXElementConstructor<any>>
  className?: string
  maxContent?: boolean
}

const CommonBody: React.VFC<IProps> = ({
  childrenWithProps,
  className = '',
  maxContent = false,
}) => {
  return (
    <PageMain className={className} maxContent={maxContent}>
      {childrenWithProps}
    </PageMain>
  )
}

const PageMain = styled.div<{ maxContent?: boolean }>`
  width: 100%;
  height: 100%;
  max-width: ${({ maxContent }) => (maxContent ? 'none' : '1340px')};
  min-width: 0;
  margin: 0 auto;
  padding: 22px 40px 80px 46px;

  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px
    margin: 0 auto;
  }
`

export default CommonBody
